import { BaseRfi } from '../../../sdk';
import { Modify } from '../../../types';

export type NormalizeRfi = Modify<
  BaseRfi,
  {
    customIdentifier: string | '-';
  }
>;

const RFIMigration = {
  deserialize: (v2RFI: BaseRfi): NormalizeRfi => ({
    ...v2RFI,
    customIdentifier: v2RFI.customIdentifier || '-',
  }),
};
export default RFIMigration;
